import React from 'react';
import ComboBox from '../../../element/combobox-check';
import Title from '../../../element/title';
import clone from 'clone';
import url from '../../../urlhandler/urlHandlerActions';
import { findIndex } from 'underscore';

const $ = jQuery;
const RE = REBUILDER;

class ComboBoxPreview extends React.Component {
  constructor(props) {
    super(props);
    this.handleComboBox = this.handleComboBox.bind(this);
    this.optionsInAdaptiveSearch = this.optionsInAdaptiveSearch.bind(this);
    this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
    this.filterable = API.filterable === 'true' ? true : false;
    this.state = {
      'values': [],
      'options': [],
      'toogle': false,
    };
    this.changeToogle = this.changeToogle.bind(this);
  }
  componentWillReceiveProps(nextprops) {
    this.setState({ toogle: nextprops.dropdonwtoggle[nextprops.block['uid']] });
    this.block = nextprops.block;
  }
  handleComboBox(values) {
    url.push({
      'searchItem': this.searchItem,
      'searchType': this.searchType,
      'searchField': 'comboBox',
      options: this.helperData.terms[this.block.selectedTaxonomy].linear,
      values,
    });
  }
  changeToogle() {
    const toogle = !this.state.toogle;
    this.setState({ toogle });
  }
  optionsInAdaptiveSearch(item, optionsArray) {
    const isThere = findIndex(this.tempOptions, { slug: item.slug });
    if (isThere === -1) {
      const indexOfSlug = findIndex(optionsArray, { slug: item.slug });
      optionsArray.splice(indexOfSlug, 1);
      return;
    }
    if (item.children.length === 0) {
      return;
    }
    for (let i = item.children.length - 1; i >= 0; i--) {
      this.optionsInAdaptiveSearch(item.children[i], item.children);
    }
    return;
  }
  render() {
    this.helperData = clone(this.props.helperData);
    this.block = this.props.block;
    // let options = [];
    let values = this.state.values;
    const urlData = this.props.urlData;
    if (urlData.hasOwnProperty('pagenumber')) {
      delete urlData['pagenumber'];
    }
    if (this.block.selectedDataType !== null) {
      // taxonomies
      if (this.block.selectedDataType === 'taxonomies' && this.helperData) {
        const previousOptions = this.options;
        this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].complex : [];
        this.searchType = 'taxonomies';
        this.searchItem = this.block.selectedTaxonomy;
        const optionsInLinear = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].linear : [];
        const allUrlData = [];
        window.searchArray.map((item) => {
          if (item.key.toString() !== 'pagenumber' && item.key.toString() !== 'view') {
            allUrlData.push(item);
          }
        });
        const topKey = allUrlData.length !== 0 ? allUrlData[allUrlData.length - 1].key : null;
        this.tempOptions = [];
        const availableDataForGrid = this.props.previewData.data;
        if (topKey !== null && this.filterable !== true) {
          if (this.searchItem !== topKey) { // the searchItem is not the top
            optionsInLinear.map((item) => {
              availableDataForGrid.map((singleItem) => {
                const isAlreadyATakenOption = findIndex(this.tempOptions, { slug: item.slug });
                const optionIndex = _.indexOf(singleItem.terms[this.searchItem], item.slug);
                if ((optionIndex !== -1 && isAlreadyATakenOption === -1)) {
                  this.tempOptions.push(item);
                }
              });
            });
            for (let i = this.options.length - 1; i >= 0; i--) {
              this.optionsInAdaptiveSearch(this.options[i], this.options);
            }
          } else {
            if (Object.keys(urlData).length === 1) {
              this.options = this.helperData.terms[this.block.selectedTaxonomy] ? this.helperData.terms[this.block.selectedTaxonomy].complex : [];
            }
            if (Object.keys(urlData).length !== 1) {
              if (previousOptions !== undefined) {
                this.options = clone(previousOptions);
              }
            }
          }
        }
        // url case
        if (this.props.urlData.hasOwnProperty(this.searchItem)) {
          if (this.state.values.length < 1) {
            values = $.isArray(this.props.urlData[this.searchItem]) ? this.props.urlData[this.searchItem] : [this.props.urlData[this.searchItem]];
          }
        } else {
          values = [];
        }
      }
    }

    const ifOpen = this.state.toogle ? 'active' : 'toggle-option';
    const HelperClass = this.state.toogle ? 'single-component' : '';
    const checkBoxClassName = this.props.block.dynamicNameClassCheckBox;
    return (<div className={checkBoxClassName}>
        <Title
          title={this.props.block.title}
          subtitle={this.props.block.subtitle}
          toogle= {this.state.toogle}
          onToogle = {this.changeToogle}
          selectedToogleViewType = {'true'}
          dropdown = {true}
          field={this.props.block.uid}
        />
        <div className={HelperClass + ' ' + 'dropdown-template'}>
        {this.options !== undefined && this.options.length ?
        <div>
          <ComboBox
            options={this.options}
            isOpenElement={ifOpen}
            value={values}
            onSelectComboBox={this.handleComboBox}
            block={this.block}
          />
        </div> : null}
        { this.options !== undefined ? <div>
          {this.options.length === 0 && this.state.toogle ?
            <div className={'rq-no-attributes-found' + ' ' + ifOpen}>
              <h3>No attributes found</h3>
            </div> : ''}
          </div> : <div className={'rq-no-attributes-found' + ' ' + ifOpen}>
              <h3>{API.LANG.NO_ATTR_FOUND}</h3>
            </div>
        }
      </div>
    </div>);
  }
}

ComboBoxPreview.propTypes = {
  'previewData': React.PropTypes.object,
  'helperData': React.PropTypes.object,
  'urlData': React.PropTypes.object,
  'block': React.PropTypes.object,
  'shortcodeKey': React.PropTypes.number,
};

export default ComboBoxPreview;



// WEBPACK FOOTER //
// ./assets/src/frontend/preview/search/dropdown/comboboxdropdownpreview.js